import React from "react";

import styles from "./stylesProduct.module.scss";

const Heading = ({ text }) => {
  return text ? <h2 className={styles["vnr-card-heading"]}>{text}</h2> : "";
};
export default Heading;
